$(document).ready(function(){
	var browser=browserCheck();
	var os=osCheck();
	var device=deviceCheck();
	$("html").addClass(browser).addClass(os);


  // <a href="#***">の場合、スクロール処理を追加
  $('a[href*="#"]').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
  		var $target = jQuery(this.hash);
      $target = $target.length && $target || jQuery('[name="' + this.hash.slice(1) +'"]');
      if ($target.length) {
      	var targetOffset = $target.offset().top;
        $('html,body').animate({ scrollTop: targetOffset }, 1000, 'easeOutExpo');
				return false;
      }
    }
  });
  
  $('.anm').on('inview', function(event, isInView) {
    if (isInView) {
    //表示領域に入った時
      $(this).addClass('is-show');
    } else {
    //表示領域から出た時
     	//$(this).removeClass('is-show');
    }
  });
  $("#menu-btn").click(function(){
	  $("#menu").toggleClass("open");
  });
		
	if($(".validationform").length){
		//inputの下にエラー
		var validation = $(".validationform").exValidation({
			errInsertPos :"after",
			errPosition :"fixed",
		  stepValidation: true,
		  errHoverHide:false,
		  errTipCloseBtn:false,
		  scrollAdjust:0,
		  errMsgPrefix : "",
		});
		if($("#chkprivacy").prop('checked')){
			$("#submit").prop('disabled',false);
		}else{
			$("#submit").prop('disabled',true);
		}
		$("#chkprivacy").click(function(){
			if($("#chkprivacy").prop('checked')){
				$("#submit").prop('disabled',false);
			}else{
				$("#submit").prop('disabled',true);
			}		
		});
		
		
		//Edgeでラジオボタンの値が消える対策
    //各ラジオボタンの設定（value値記録）
    $('input[type=radio]').on('change', function (e) {
        var $self = $(this);
        var valueData = $self.val();
        var nameData = $self.attr('name');
        var $myDataSaveField = $('[data-name=' + nameData + ']');
        $myDataSaveField.val(valueData);
    });

    //隠しフィールドの値から復帰処理
    $('[data-name]').each(function () {
        var $self = $(this);
        var valueData = $self.val();
        if(valueData === '') return false;
        var nameData = $self.attr('data-name');
        var $groupRadioButton = $('input[name=' + nameData + ']');
        $groupRadioButton.each(function () {
            var $self = $(this);
            if ($self.val() === valueData) {
                $self.prop('checked', true);
            }
        });
    });
		
	}
	if($("#gmap").length){
		googlemap({
			"tit" : "医療法人社団信濃会",
			"lat" : 35.685283,
			"lng" : 139.720425,
			"maplat" : 35.685884, //mapの中心
			"maplng" : 139.720516, //mapの中心
			"zoom" : 17,
			"window" : "<dl id='infowin'><dt>医療法人社団信濃会</dt><dd>〒160-0017<br>東京都新宿区左門町20番地<br>四谷メディカルビル<br>信濃坂クリニック（同ビル3階）<br>左門町クリニック（同ビル6階）</dd></dl>"
		});
	}
	//スクロール
	$(window).scroll(function () {
   	var scrTop=$(this).scrollTop();//スクロール位置
   	if(scrTop>=300){
	   	$(".pagetop").addClass("show");
   	}else{
	   	$(".pagetop").removeClass("show");
   	}
  });
	//画面サイズごとの処理
	var w = $(window).width();
	deviceFunc(w);
	
	$(window).resize(function(){
  	var w = $(window).width();
	  deviceFunc(w);
	});
	
});


//画面サイズごとの処理
function deviceFunc(w){
	var bp = [599,960,1280];
	if (w <= bp[0]) {
		//sp
		$(".tel-number").each(function(){
			if(!$(this).parent(".tel-wrap").length){
				var no = $(this).data("tel");
				$(this).wrap('<a href="tel:' + no + '" class="tel-wrap"></a>');
			}
		});
  } else if(w <= bp[1]){
		//tb
		$(".tel-wrap .tel-number").each(function(){
			$(this).unwrap();
		});
  } else if(w <= bp[2]){
		//small pc
  } else{
  
  }
}
function googlemap(opt){
	var latlng = new google.maps.LatLng(opt.lat,opt.lng);
	var maplatlng = new google.maps.LatLng(opt.maplat,opt.maplng);
  var myOptions = {
    zoom: opt.zoom, /*拡大比率*/
    center: maplatlng, /*表示枠内の中心点*/
    tilt:0,
    scrollwheel: false,
    mapTypeControl:false,
    mapTypeId: google.maps.MapTypeId.ROADMAP/*表示タイプの指定*/
  };
  var map = new google.maps.Map(document.getElementById('gmap'), myOptions);
 
	/*アイコン設定▼*/
  var markerOptions = {
    position: latlng,
    map: map,
    title: opt.tit
  };
  var marker = new google.maps.Marker(markerOptions);
　/*アイコン設定ここまで▲*/

	/*情報ウィンドウ*/
  var contentString=opt.window;
  var infowindow=new google.maps.InfoWindow({
      content: contentString
  });
  infowindow.open(map,marker);//表示
  /* マーカーがクリックされた時に情報ウィンドウ表示 */
  google.maps.event.addListener(marker, 'click', function() {
      infowindow.open(map,marker);
  });
}

/*ブラウザ判別*/
function browserCheck(){
	var ua = window.navigator.userAgent.toLowerCase();
	var av = window.navigator.appVersion.toLowerCase();
	if(ua.indexOf('edge') != -1){
		return 'edge';
	}else if (ua.indexOf('opera') != -1) {
  	return 'opera';
	}else if (ua.indexOf("msie") != -1 || ua.indexOf("trident") != -1) {
		$("body").addClass('ie');
  	if (av.indexOf("msie 6.") != -1) {
    	return 'ie6';
  	} else if (av.indexOf("msie 7.") != -1) {
    	return 'ie7';
  	} else if (av.indexOf("msie 8.") != -1) {
    	return 'ie8';
  	} else if (av.indexOf("msie 9.") != -1) {
    	return 'ie9';
  	}else if (av.indexOf("msie 10.") != -1) {
    	return 'ie10';
  	}else if (av.indexOf("rv:11.") != -1) {
    	return 'ie11';
  	}
	} else if (ua.indexOf('chrome') != -1) {
  	return 'chrome';
	} else if (ua.indexOf('safari') != -1) {
  	return 'safari';
	} else if (ua.indexOf('gecko') != -1) {
  	return 'firefox';
	} else {
  	return false;
	}
}

/*OS判別*/
function osCheck(){
	var ua = window.navigator.userAgent.toLowerCase();
	if (ua.indexOf('windows') != -1) {
		if(ua.indexOf('phone') != -1){
			return 'winphone';
		}else{
			return 'win';
		}
	}else if(ua.indexOf('iphone') != -1) {
		return 'iphone';
	}else if(ua.indexOf('ipad') != -1) {
		return 'ipad';
	}else if(ua.indexOf('mac') != -1) {
		return 'mac';
	}else if(ua.indexOf('android') != -1) {
		if(ua.indexOf('mobile') != -1){
			if(ua.indexOf('A1_07') != -1){
				return 'tablet';
			}else if(ua.indexOf('SC-01C') != -1){
				return 'tablet';
			}else{	return 'android';}
		}else{
			return 'tablet';
		}
	}else{
		return false;
	}
}

/*デバイス判別*/
function deviceCheck(){
	var ua = window.navigator.userAgent.toLowerCase();
	if((ua.indexOf("windows") != -1 && ua.indexOf("touch") != -1 && ua.indexOf("tablet pc") == -1) 
      || ua.indexOf("ipad") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") == -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("tablet") != -1)
      || ua.indexOf("kindle") != -1
      || ua.indexOf("silk") != -1
      || ua.indexOf("playbook") != -1){
      return 'tab';
    }else if((ua.indexOf("windows") != -1 && ua.indexOf("phone") != -1)
      || ua.indexOf("iphone") != -1
      || ua.indexOf("ipod") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") != -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("mobile") != -1)
      || ua.indexOf("blackberry") != -1){
	    return 'sp';
    }else{
      return 'pc';
    }
}